import React, { PropTypes }          from 'react';
import { get, isEmpty }              from 'lodash';
import { isLocal, isMobile, isIpad } from 'utils/util';
import { Link }                      from 'react-router';
import ShareMenu                     from 'components/medscape_tv/share_menu';
import Transcript                    from 'components/medscape_tv/transcript';
import Comments                      from 'components/medscape_tv/comments';
import VideoActions                  from 'actions/video_actions';
import TrackingActions               from 'actions/tracking_actions';
import Animation                     from 'utils/animation';
import HasPrettyTime                 from 'mixins/has_pretty_time';


require('classlist');
export default React.createClass({
  displayName: 'MedscapeTV.TitleBar',
  propTypes: {
    chapters: PropTypes.array,
       index: PropTypes.number
  },
  mixins: [HasPrettyTime],
  getInitialState() {
    return {
      transcriptIsVisible: false,
      commentingIsVisible: false
    };
  },
  componentDidMount() {
    const ifiContainer = document.querySelector('.ifiLinks');
    if(ifiContainer !== null) {
      const ifiLinks = ifiContainer.getElementsByTagName('a');
      Array.prototype.forEach.call(ifiLinks, (link)=>{
        if(link.host === window.location.host) {
          link.addEventListener('click', ()=>{
            TrackingActions.internalLink();
          });
        } else {
          link.addEventListener('click', ()=>{
            TrackingActions.externalLink();
          });
        }
      });
    }
    window.mtvHideOverlayTranscript = this.hideTranscript;
    window.mtvShowOverlayTranscript = this.showTranscript;
    window.mtvHideOverlayComments   = this.hideComments;
    window.mtvShowOverlayComments   = this.showComments;
    document.getElementById('comments-hide-btn').addEventListener('click', ()=> {
      window.mtvHideOverlayComments();
    });
    document.getElementById('transcript-hide-btn').addEventListener('click', ()=> {
      window.mtvHideOverlayTranscript();
    });
  },
  componentDidUpdate() {
    const ifiContainer = document.querySelector('.ifiLinks');
    if(ifiContainer !== null) {
      const ifiLinks = ifiContainer.getElementsByTagName('a');
      Array.prototype.forEach.call(ifiLinks, (link)=>{
        if(link.host === window.location.host) {
          link.addEventListener('click', ()=> {
            TrackingActions.internalLink();
          });
        } else {
          link.addEventListener('click', ()=> {
            TrackingActions.externalLink();
          });
        }
      });
    }
  },
  showTranscript() {
    TrackingActions.transcriptOpen();
    window.trackingEnabled = false;
    this.setState({
      transcriptIsVisible: true,
                wasPaused: document.querySelector('video').paused
    });
    VideoActions.pause();
    document.body.classList.add('overlayed');
    Animation.slideFadeIn(document.getElementById('medscape-tv-transcript'), document.getElementsByClassName('medscape-tv-transcript')[0]);
  },
  hideTranscript() {
    TrackingActions.transcriptClose();
    window.trackingEnabled = false;
    if(!this.state.wasPaused) {
      VideoActions.start();
    }
    this.setState({
      transcriptIsVisible: false,
                wasPaused: document.querySelector('video').paused
    });
    document.body.classList.remove('overlayed');
    Animation.slideFadeOut(document.getElementById('medscape-tv-transcript'), document.getElementsByClassName('medscape-tv-transcript')[0]);
  },
  showComments() {
    TrackingActions.commentsOpen();
    window.trackingEnabled = false;
    VideoActions.pause();
    document.body.classList.add('overlayed');
    this.setState({
      commentingIsVisible: true,
                wasPaused: document.querySelector('video').paused
    });
    document.body.classList.add('overlayed');
    Animation.slideFadeIn(document.getElementById('medscape-tv-comments'), document.getElementsByClassName('medscape-tv-comments')[0]);
  },
  hideComments() {
    TrackingActions.commentsClose();
    window.trackingEnabled = false;
    if(!this.state.wasPaused) {
      VideoActions.start();
    }
    this.setState({
      commentingIsVisible: false,
                wasPaused: document.querySelector('video').paused
    });
    document.body.classList.remove('overlayed');
    Animation.slideFadeOut(document.getElementById('medscape-tv-comments'), document.getElementsByClassName('medscape-tv-comments')[0]);
  },
  track(upNextChapter) {
    if(!upNextChapter.isAdvertisement) {
      TrackingActions.selectVideo(`vidmtv-show_${get(this, 'upNextChapter.video.videoIndex', 0) + 1 }`);
    } else {
      TrackingActions.selectVideo(`vidmtv-show_ifi`);
    }
  },
  render() {
    const chapters = get(this, 'props.chapters', []);
    if(isEmpty(chapters)) {
      return null;
    }
    const activeChapter = chapters[this.props.index],
          upNextChapter = chapters[this.props.index + 1];
      let  transcriptComponent, commentComponent,  shareMenuComp, commentsComp,
           transcriptComp, upNextElement, topBar, title = '', label = '';
      title = `${activeChapter.title}`;
    if(activeChapter) {
      if(activeChapter.isAdvertisement) {
        label = (<span className="label-advertisment">INFORMATION FROM INDUSTRY</span>);
      } else {
        if(isMobile() && !isIpad()) {
          if(activeChapter.videoTag !== '') {
            label = (<span className="label-episode">{activeChapter.videoTag} | {activeChapter.duration}</span>);
          } else {
            label = (<span className="label-episode">Episode {activeChapter.videoIndex +  1} | {this.secondsToPrettyTime(activeChapter.duration, 2)}</span>);
          }
        } else if(activeChapter.videoTag !== '') {
          label = (<span className="label-episode">{activeChapter.videoTag}</span>);
        } else if(activeChapter.isIndexed) {
          label = (<span className="label-episode">SEASON 1 - Episode {activeChapter.videoIndex +  1}</span>);
        }
      }
    }
    if(get(activeChapter, 'hasSocialMedia', true))  {
      transcriptComponent = (<Transcript videoUrlFragment={activeChapter.videoUrlFragment} />);
      commentComponent = (<Comments videoUrlFragment={activeChapter.videoUrlFragment} />);
      if(activeChapter.hasShare) {
        shareMenuComp = <ShareMenu ref="shareMenuRef" />;
      }
      if(activeChapter.hasComments) {
        commentsComp = <div onClick={this.showComments} className="comments-wrap">Comments</div>;
      }
      if(activeChapter.hasTranscript) {
        transcriptComp = <div onClick={this.showTranscript} className="transcript-wrap">Transcript</div>;
      }
      topBar = (<div className="social-media-wrap">
                  { label }
                  { shareMenuComp }
                  { commentsComp }
                  { transcriptComp }
                </div>);
    } else {
      topBar = (<div className="social-media-wrap">
                  { label }
                </div>);
    }
    let ifiLinks = null;
    if(activeChapter.ifiHTML) {
      ifiLinks = (<div className="ifiLinks" dangerouslySetInnerHTML={{ __html: activeChapter.ifiHTML }} />);
    }
    if(typeof upNextChapter !== 'undefined' && typeof upNextChapter.source !== 'undefined') {
      let upNextChapterlabel = null;
      const basePath = isLocal()? '': `/mtv/${window.MedscapeTVInstance.seriesUrlFragment}`;
      if(upNextChapter.isAdvertisement) {
        upNextChapterlabel = (<span className="label-advertisment">INFORMATION FROM INDUSTRY</span>);
      }
      upNextElement = (<Link className="upNextChapter" onClick={this.track} to={`${basePath}/${upNextChapter.videoUrlFragment}`}>
                        <h1>UP NEXT</h1>
                        { upNextChapterlabel }
                        <div className="upNextChapterTitle"> { upNextChapter.title }</div>
                       </Link>);
    }
    return (
      <div className="medscape-tv-chrome">
        <div className="chrome-row">
          <div className="chrome-cell">
            { ifiLinks }
            { topBar }
            { transcriptComponent }
            { commentComponent }
            <h1 className="medscape-tv-chrome-title"
                dangerouslySetInnerHTML={{ __html: title }} />
          </div>
          { upNextElement }
        </div>
      </div>
    );
  }
});



/** WEBPACK FOOTER **
 ** ./modules/components/medscape_tv/title_bar.jsx
 **/